import React from 'react';
import ReactDOM from 'react-dom';
import PlantSite from './images/pngcellpic.png';
import WeatherApp from './images/WeatherAppPhone.png';
import FlashCards from './images/Phoneproject.png';
import MovieRecommendation from './images/MovieRecommendation.png';
import './CSS/ProjectButtonStyle.css';
import './CSS/ProjectTemplate.css';

  
  class ProjectDescriptions extends React.Component {
    constructor(props) {
      super(props);
  
      // This binding is necessary to make `this` work in the callback
     this.clickToProject = this.clickToProject.bind(this);
     this.clickToSourceCode = this.clickToSourceCode.bind(this);
    }
  
    clickToProject() {
        window.location.href = this.props.projectUrl;
      
    }
    clickToSourceCode() {
        window.location.href = this.props.sourceCodeUrl;
      
    }
  
    render() {
      return (
       <div>
           <div class="col-12 pt-5" >
                <img id={this.props.projectName} class="projectImage img-fluid" src={this.props.projectPhoto} alt="queen" />
           </div>
           <div class="col-12 pb-3" >
               <p>{this.props.descriptionText}</p>
               <p id="nameofproject">{this.props.projectName}</p>
               <p id="languages">{this.props.languages}</p>
               <p id="textaboutprojects">{this.props.descriptionProject}</p>
               <button class="projectButtonsStyle projectButton" onClick={this.clickToProject}>
                    See Live
                </button>
                <button class="projectButtonsStyle projectButton" onClick={this.clickToSourceCode}>
                    Source Code
                </button>
           
           </div>  
       </div>  

      );
    }
  }
  
  ReactDOM.render(
    <React.StrictMode>
    <ProjectDescriptions projectPhoto={MovieRecommendation} projectName="Movie Recommendations" projectUrl = "https://movierecommendationstanya.azurewebsites.net/" languages="REACT.JS/CSS//FLEXBOX" descriptionProject="This project was built to practice my React.js skills, and provide movie recommendations for user based on movie genres."   sourceCodeUrl="https://github.com/Tanya-design93/tanya-design93.github.io/tree/main/movie-recomendations"/>
    </React.StrictMode>,
    document.getElementById('projectOne')
  );

  ReactDOM.render (
    <React.StrictMode>
      <ProjectDescriptions projectPhoto={FlashCards}  projectName="Flashcards"projectUrl = "https://tanya-design93.github.io/Flashcards/Homepage.html" languages="JS/CSS/HTML/BOOTSTRAP" descriptionProject="This Flash Card app was built to better understand how to dynamically create objects in JavaScript, and display them in a pleasing manner. This was also my first project where I used Bootstrap to help position the cards."   sourceCodeUrl="https://github.com/Tanya-design93/tanya-design93.github.io/tree/main/Flashcards" />
    </React.StrictMode>,
    document.getElementById('projectTwo')
  );
  
  ReactDOM.render (
    <React.StrictMode>
      <ProjectDescriptions projectPhoto={WeatherApp}  projectName="Weather App"projectUrl = "https://tanya-design93.github.io/Weather%20App/index.html" languages="JS/CSS/HTML/BOOTSTRAP" descriptionProject="The weather app was my first intro into using external APIs and extracting information from users. Through grabbing a users location from their cookie, I was able to submit this information to a public api, which in turn gave me the users weather in JSON format."   sourceCodeUrl="https://github.com/Tanya-design93/tanya-design93.github.io/tree/main/Weather%20App" />
    </React.StrictMode>,
    document.getElementById('projectThree')
  );
  
  ReactDOM.render (
    <React.StrictMode>
      <ProjectDescriptions projectPhoto={PlantSite}  projectName="Plant site" projectUrl = "https://tanya-design93.github.io/PlantApp/" languages="JS/CSS/HTML/BOOTSTRAP" descriptionProject="This plant app was a good introduction into using a mocked backend interface which in this case was a JSON file. The JSON file contained numerous pieces of information about plants. With a bootstrap and css front end. Javascript was utilized in order to create a searchable interface for users to view and read about certain breeds of plants. The two main ways a user could search for plants was through 3 predefined categories, while also having the ability to perform a partial text search."   sourceCodeUrl="https://github.com/Tanya-design93/tanya-design93.github.io/tree/main/PlantApp"/>
    </React.StrictMode>,
    document.getElementById('projectFour')
  );